import { useCallback, useContext } from 'react';
import { match } from 'ts-pattern';

import { RootModalsContext } from '~/domains/common/context/RootModalsContext/RootModalsContext';

import { getWithdrawalLocationPrompt } from '../utils/withdrawalLocationPrompt';

export function useWithdrawalLocationErrorHandler() {
  const { openModalUnique, closeModalsByType } = useContext(RootModalsContext);

  return useCallback(
    (error: unknown, retry: VoidFunction) => {
      const prompt = getWithdrawalLocationPrompt(error);

      if (!prompt) return false;

      match(prompt)
        .with('permission', () =>
          openModalUnique({
            type: 'LocationPermissionRequiredModal',
            onRecheckPermission: () => {
              closeModalsByType('LocationPermissionRequiredModal');
              retry();
            },
          })
        )
        .with('recheck', () =>
          openModalUnique({
            type: 'LocationErrorModal',
            onRecheckLocation: () => {
              closeModalsByType('LocationErrorModal');
              retry();
            },
          })
        )
        .exhaustive();

      return true;
    },
    [openModalUnique, closeModalsByType]
  );
}
